import React, { useEffect, useState } from "react";
import { fetchFileBlobUrl } from "../api/fileApi";

/**
 * Read-only counterpart to `PhotoUpload` — fetches one student's photo as an
 * authenticated blob (a plain `<img src="/api/files/...">` can't carry the
 * Bearer token) for display in a roster/card view, e.g. admit cards and seat
 * plans. Silently shows nothing if the student has no photo or it fails to
 * load, matching how the print-ready pages elsewhere in this app degrade.
 */
export default function StudentPhoto({ fileName, alt, className }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;

    if (fileName) {
      fetchFileBlobUrl("students", fileName)
        .then((u) => {
          if (!cancelled) {
            objectUrl = u;
            setUrl(u);
          }
        })
        .catch(() => {
          if (!cancelled) setUrl(null);
        });
    } else {
      setUrl(null);
    }

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileName]);

  if (!url) {
    return <div className={className} aria-hidden="true" />;
  }
  return <img className={className} src={url} alt={alt || ""} />;
}
